import ApiService from './api.service'
import { TokenService, UserInfo } from './storage.service'


class AuthenticationError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const UserService = {
    login: async function(email, password) {

        try {
            const response = await ApiService.post("login", {
                username: email,
                password: password
            });
            UserInfo.save(JSON.stringify(response.data.user));
            TokenService.saveToken(response.data.token)
            //TokenService.saveRefreshToken(response.data.refresh_token)
            ApiService.setHeader();
            ApiService.mount401Interceptor();

            return response.data.token
        } catch (error) {
            throw new AuthenticationError(error.response.status, '')
        }
        
    },
    logout() {
        TokenService.removeToken()
        TokenService.removeRefreshToken()
        ApiService.removeHeader()
        localStorage.clear();
    },
    saveEmployees: async function(employees, activeEmployees){  
        const response = await ApiService.post('save-workers', {
            totalWorkers:Number(employees),
            activeWorkers: Number(activeEmployees)
        })
        return response.data
    },
    selectPlan: async function(id, period){  
        const response = await ApiService.post('save-plan', {
            plan:Number(id),
            period:Number(period)
        })
        return response.data
    },
    solicitud: async function(plan, period, category){  
        const response = await ApiService.post('confirm', {
            plan:Number(plan),
            period:Number(period),
            category:Number(category)
        })
        return response.data
    },
    confirmCustom: async function(comment){  
        const response = await ApiService.post('confirmCustom', {
            comment:comment
        })
        return response.data
    },
    getFile: async function(){  
        const response = await ApiService.get('getmembership',{})
        return response.data
    }
}

export default UserService

export { UserService, AuthenticationError }
